module.exports = __webpack_public_path__ + "img/svg_bg.6bc84081.svg";